var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMorrisonsDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.5,
    stroke: "#00893F",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17H21V27H16V17Z",
    fill: "#FFC20E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27H25.4C26.28 27 27 26.1818 27 25.1818V17H23V27Z",
    fill: "#FFC20E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2105 11H11.7895C10.8053 11 10 11.72 10 12.6V15H27V12.6C27 11.72 26.1947 11 25.2105 11Z",
    fill: "#FFC20E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 25.1818C10 26.1818 10.72 27 11.6 27H14V17H10V25.1818Z",
    fill: "#FFC20E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorrisonsDocuments);
export default __webpack_public_path__ + "static/media/morrisons-documents.908ca1f2.svg";
export { ForwardRef as ReactComponent };